import axios from "axios";
import React, { useContext, useEffect } from "react";
import { useHistory } from "react-router";
import styled from "styled-components";
import { UserContext } from "../UserContext";

const CreditDebit = () => {
  const history = useHistory();

  const [user] = useContext(UserContext);
  const transfer = async (e) => {
    e.preventDefault();
    const data = new FormData(e.target);
    const acc_no = data.get("account_number");
    const amount = data.get("amount");
    const type = data.get("credit_debit");

    const response = await axios.post(
      "https://salt-neobank.herokuapp.com/admin/transfer",
      {
        acc_no: acc_no,
        amount: amount,
        type: type,
      }
    );

    alert(response.data);
  };
  useEffect(() => {
    if (user.role === "unauthenticated") {
      history.push("/");
    }
  }, [history, user.role]);
  return (
    <Container>
      <TransferForm onSubmit={(e) => transfer(e)}>
        <label htmlFor="account_number">Account Number</label>
        <input
          type="text"
          name="account_number"
          id="account_number"
          pattern="[0-9]{16}"
          required
        />
        <label htmlFor="amount">Amount</label>
        <input
          type="text"
          name="amount"
          id="amount"
          pattern="[0-9]*"
          required
        />
        <div style={{ cursor: "pointer" }}>
          <input
            type="radio"
            name="credit_debit"
            id="credit"
            value="credit"
            required
          />
          <label htmlFor="credit" style={{ cursor: "pointer" }}>
            Credit
          </label>
        </div>
        <div style={{ cursor: "pointer" }}>
          <input
            type="radio"
            name="credit_debit"
            id="debit"
            value="debit"
            required
          />
          <label htmlFor="debit" style={{ cursor: "pointer" }}>
            Debit
          </label>
        </div>
        <button type="submit">Transfer</button>
      </TransferForm>
    </Container>
  );
};
const Container = styled.div``;
const TransferForm = styled.form`
  display: flex;
  flex-direction: column;
  & > * {
    margin: 0.5em 0;
  }
  input {
    padding: 0.5em;
    border: none;
    border-radius: 4px;
    :focus {
      outline: none;
      border: 1px solid #f5642f;
    }
  }
  button {
    border-radius: 4px;
    padding: 0.5em;
    border: none;
    background-color: #f5642f;
    color: white;
    font-size: 1.1rem;
    cursor: pointer;
  }
`;

export default CreditDebit;
